export default function initAjaxNewsletter() {
  const $form = $('.newsletter-form');

  if ($form.length < 1) {
    return false;
  }

  $form.on('submit', (e) => {
    if ($('input[name="challenge"]', $form).val() == "true") {
      return true;
    }

    $form.find('.button').text('Joining').addClass('disabled');

    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      success: () => {
        const $successMessage = $('<p class="newsletter-success">' + Shopify.translation.newsletter_form_success + '</p>');

        $form.find('.newsletter-input').addClass('successful');
        $form.prepend($successMessage);
      },
      error: () => {
        $('input[name="challenge"]', $form).val('true');
        $form.submit();
      }
    });

    e.preventDefault();
    return false;
  });
};
